import { NgClass } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { Icons } from '../../icon/constants/icons.constants';
import { IconComponent } from '../../icon/icon.component';
import { getIcon } from '../models/helpers';
import { NotificationTypeKeys } from '../models/notification-type.model';

@Component({
    selector: 'nw-notification-bar',
    // kept *.component.html for now as ESLint is not configured to handle *.html files
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, NgClass]
})
export class NotificationBar implements OnChanges {
    @Input() type: NotificationTypeKeys = 'information';
    @Input({ transform: booleanAttribute }) invert: boolean = false;
    @Input({ transform: booleanAttribute }) vertical: boolean = false;

    icon: Icons.Type = Icons.Alerts.circle_info;

    public ngOnChanges({ type }: SimpleChanges): void {
        if (type?.currentValue) this.icon = getIcon(type.currentValue);
    }
}
